import type { TemplateBlocksSectionProps } from '~/components/TemplateBlocksSection/TemplateBlocksSection';
import { TouchCampaignGraph } from '~/components/TouchCampaignGraph/TouchCampaignGraph';

type Props = {
  /** Shared editor wiring (documents / reminders / sift / @-variables). */
  editorContext: Omit<TemplateBlocksSectionProps, 'cadenceTemplate'>;
  cadenceTemplate: TemplateBlocksSectionProps['cadenceTemplate'];
};

/**
 * Touch campaign graph on the contact detail Interact tab. Always the same
 * draggable, branching node-canvas (dotted background, edges, pan) the template
 * page uses. The Minimal / Expanded toggle (mirroring the campaign switch) only
 * changes each touch's node density — compact icon chips vs the full card — so
 * branches (No branch, fork arms) stay visible in BOTH modes. Starts in Minimal
 * so the graph keeps a small footprint. Wheel scrolls the page (drag to pan).
 */
export function ContactTouchGraphPanel({ editorContext, cadenceTemplate }: Props) {
  return (
    <div className="relative h-[70vh] min-h-[420px] w-full overflow-hidden rounded-lg border border-lynch-200 dark:border-slate-700">
      <TouchCampaignGraph
        {...editorContext}
        cadenceTemplate={cadenceTemplate}
        hideCandidates
        disableWheelPan
        showViewToggle
        defaultMinimal
      />
    </div>
  );
}
